"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _VolumeControl = require("../VolumeControl/VolumeControl");
var SourceVolumeControl = function SourceVolumeControl(_ref) {
  var type = _ref.type,
    live = _ref.live,
    sourceId = _ref.sourceId,
    enableFeature = _ref.enableFeature,
    isAudioSource = _ref.isAudioSource,
    _ref$muted = _ref.muted,
    muted = _ref$muted === void 0 ? false : _ref$muted,
    volume = _ref.volume,
    onVolumeChanged = _ref.onVolumeChanged;
  return /*#__PURE__*/_react["default"].createElement(_VolumeControl.VolumeControl, {
    type: type,
    live: live,
    id: sourceId,
    enableFeature: enableFeature,
    isAudioSource: isAudioSource,
    muted: muted,
    volume: volume,
    onVolumeChanged: enableFeature ? onVolumeChanged : function () {}
  });
};
SourceVolumeControl.propTypes = {
  type: _propTypes["default"].string,
  onVolumeChanged: _propTypes["default"].func,
  sourceId: _propTypes["default"].string.isRequired,
  muted: _propTypes["default"].bool,
  isAudioSource: _propTypes["default"].bool,
  volume: _propTypes["default"].number,
  live: _propTypes["default"].bool,
  enableFeature: _propTypes["default"].bool
};
var _default = exports["default"] = SourceVolumeControl;